import { Texts } from '../../Object';

const Table = (props) => {
  const slug = props.slug;

  const Item = (props) => {
    return(
      <>
        <li className="c-table__items">
          <div className="c-table__items--left">
            <Texts class="c-text--bold c-text--main" slug={`${slug}/label${props.index}`} />
          </div>
          <div className="c-table__items--right">
            <Texts slug={`${slug}/value${props.index}`} />
          </div>
        </li>
      </>
    )
  }

  const Items = [];
  for (let i = 0; i < props.len; i++) {
    Items.push(
      <Item key={i} index={i} />
    )
  }

  return(
    <>
      <ul className="c-table__list">
        {Items}
      </ul>
    </>
  )
}

export default Table;
